import { styled } from "@linaria/react";

import { withTheme } from "../theme/GalaxyTheme";
import type { PropsWithTheme } from "../theme/types";

import { getCssSizeValue } from "../utils/linaria";

export interface TextShimmerProps {
  height: number | string;
  width: number | string;
  noBorderRadius?: boolean;
}

const StyledTextShimmer = withTheme(styled.span<
  PropsWithTheme<{
    $height: number | string;
    $width: number | string;
    $noBorderRadius?: boolean;
  }>
>`
  display: inline-block;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.color.border.primary} 0%,
    ${({ theme }) => theme.color.border.primary} 75%,
    ${({ theme }) => theme.color.border.primary} 100%
  );
  background-size: 200% 100%;
  animation:
    shimmer 2.5s infinite,
    pulse 2.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  height: ${({ $height }) => getCssSizeValue($height)};
  width: ${({ $width }) => getCssSizeValue($width)};

  border-radius: ${({ $noBorderRadius }) => ($noBorderRadius ? "0" : "4px")};

  @keyframes shimmer {
    0% {
      background-position: -250% 0;
    }
    100% {
      background-position: 150% 0;
    }
  }

  @keyframes pulse {
    0%,
    100% {
      opacity: 0.75;
    }
    50% {
      opacity: 0.25;
    }
  }
`);

const TextShimmer = ({ height, width, noBorderRadius }: TextShimmerProps) => {
  return <StyledTextShimmer $height={height} $width={width} $noBorderRadius={noBorderRadius} />;
};

export default TextShimmer;
